<template>
    <Head title="Grades" />

    <BreezeAuthenticatedLayout>
      <main class="container">
        <div class="py-12">

          <div class="c-header">
            <a href="" onclick="javascript:history.back(); return false;" class="c-header__back">
              <img src="/images/icons/icon-chevron-left.svg" alt="back">
            </a>
            <h2 class="c-header--h2">グレード：編集</h2>
          </div>

          <div class="mt-24">
            <form @submit.prevent="updateGrade">
              <div>
                <label for="title">グレード</label>
                <div class="mt-1">
                  <input type="text" id="title" wire:model.lazy="title" name="title" v-model="form.title">
                </div>
              </div>

              <div class="mt-24">
                <label for="color">色</label>
                <div class="mt-1">
                  <VSwatches v-model="form.color" :swatches="swatches" show-border=true />
                </div>
              </div>

              <div class="mt-24">
                <button type="submit" class="c-button">更新する</button>
              </div>
            </form>
          </div>

        </div>
        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side'

  import { ref } from "vue";
  import VSwatches from "vue3-swatches";

  const color = ref("#ff0000");

  // import Swatches from 'vue-swatches';
  // import "vue-swatches/dist/vue-swatches.min.css"
  // import VSwatches from 'vue-swatches'
  // Import the styles too, globally
  // import "vue-swatches/dist/vue-swatches.css"

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Inertia,
      Side,
      VSwatches,
    },

    props: {
      grade: Object,
      swatches: Array
    },

    setup(props) {
      const form = useForm({
        title: props.grade.title,
        color: props.grade.color,
      });
      const swatches = ['#dc143c', '#ff4500', '#ff8c00', '#ffdd00', '#9acd32', '#006400', '#87cefa', '#0000cd', '#191970', '#4b0082', '#8a2be2', '#a9a9a9', '#8b4513', '#222222', '#fc9db8', '#ffffff'];

      return { form, swatches };
    },

    methods: {
      updateGrade() {
        Inertia.post(`/grades/${this.grade.id}`, {
        _method: 'put',
        title: this.form.title,
        color: this.form.color,
      })
      // this.form.put(route("projects.update", this.project.id));
      // },
    },
    }
  }
</script>
